import { render, staticRenderFns } from "./SpeakerStars.vue?vue&type=template&id=4dc5ec28&scoped=true&"
import script from "./SpeakerStars.vue?vue&type=script&lang=js&"
export * from "./SpeakerStars.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerStars.vue?vue&type=style&index=0&id=4dc5ec28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5ec28",
  null
  
)

export default component.exports